import { render, staticRenderFns } from "./CameraDetail.vue?vue&type=template&id=8e2996b4&scoped=true&"
import script from "./CameraDetail.vue?vue&type=script&lang=js&"
export * from "./CameraDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e2996b4",
  null
  
)

export default component.exports